import { Row } from "reactstrap";
import HeaderLogo from "./HeaderLogo";
import SearchInput from "./search-input/SearchInput";
import { useAppSelector } from "../../redux-tool-kit/Hooks";
import RightHeaderIcon from "./right-header-icon/RightHeaderIcon";

const Header = () => {
  const { toggleSidebar,scroll } = useAppSelector((state) => state.layout);
  return (
    <Row className={`header-wrapper m-0 ${toggleSidebar ? "close_icon" : ""}`} style={{display: scroll ? "none" : ""}}>
      <HeaderLogo />
      <SearchInput />
      <RightHeaderIcon />
    </Row>
  );
};

export default Header;
